import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { BsModalRef, BsDatepickerConfig } from "ngx-bootstrap";
import { DatePipe, DecimalPipe } from "@angular/common";
import { TargetAccount, SourceAccount } from '../../../../../projects/accounting/src/public_api';

export enum PaymentEditorType {
  income,
  expense
}

export interface PaymentEditorData {
  shortName: string,
  name: string;
  address: string;
  type: PaymentEditorType;
  accounts: Array<TargetAccount> | Array<SourceAccount>;
  account: string;
  amount: number;
  date?: string;
  deposit?: boolean;
}

@Component({
  selector: 'payment-editor',
  templateUrl: './payment-editor.component.html',
  styleUrls: ['./payment-editor.component.scss']
})
export class PaymentEditorComponent implements OnInit {

  public bsDate = new Date();
  selectedAccount = null;
  amount = 0;
  @Input() data: PaymentEditorData;
  @Output() commit = new EventEmitter();

  public bsConfig: BsDatepickerConfig = {
    containerClass: 'theme-angle custom-date',
    dateInputFormat: 'DD/MM/YYYY',
    displayMonths: 1,
    showWeekNumbers: false,
    rangeSeparator: " - ",
    rangeInputFormat: "DD/MM/YYYY",
    monthTitle: "TMM",
    yearTitle: "YYYY",
    dayLabel: "DD",
    monthLabel: "",
    yearLabel: "",
    weekNumbers: "",
    maxDate: new Date()
  };

  messageDate = '';
  messageCode = '';
  confirmation = '';

  getTitle() {
    switch (this.data.type) {
      case PaymentEditorType.income: return this.data.deposit === true ? 'Ghi nhận đặt cọc từ' : 'Ghi nhận thu từ';
      case PaymentEditorType.expense: return this.data.deposit === true ? 'Ghi nhận đặt cọc cho' : 'Ghi nhận chi tới';
      default: return null;
    }
  }

  getAccountTitle() {
    switch (this.data.type) {
      case PaymentEditorType.income: return 'Tài khoản nhận';
      case PaymentEditorType.expense: return 'Tài khoản chuyển';
      default: return null;
    }
  }

  getDateTitle() {
    switch (this.data.type) {
      case PaymentEditorType.income: return 'Ngày nhận tiền';
      case PaymentEditorType.expense: return 'Ngày chuyển tiền';
      default: return null;
    }
  }

  getAmountTitle() {
    switch (this.data.type) {
      case PaymentEditorType.income: return 'Số tiền nhận được';
      case PaymentEditorType.expense: return 'Số tiền đã chuyển';
      default: return null;
    }
  }

  constructor(
    public modalRef: BsModalRef,
    private date: DatePipe,
    private decimal: DecimalPipe,
  ) {
  }

  ngOnInit() {
    if (this.data.accounts.length < 2) {
      this.data.account = this.data.accounts[0].name;
    }
    let min = new Date();
    min.setDate(min.getDate() - 90);
    this.bsConfig.minDate = min;
  }
  getCode(){
    if(this.selectedAccount == null){
      return 'Bạn chưa chọn thông tin ngân hàng';
    }
    if (!this.validateDate()){
      return;
    }
    if(this.amount == 0){
      return 'Số tiền không hợp lệ';
    }

    return 'Nhập mã <b class="text-uppercase">'+this.data.shortName + '^' + this.selectedAccount+ '^' + this.getConfirmNumber()+'</b> để xác nhận';

  }
  getConfirmNumber(){
    let s = this.amount + '';

    if (s.length > 9){
      return s.slice(0, s.length - 9) + 'TY';
    }
    if (s.length > 6){
      return s.slice(0, s.length - 6) + 'TRIEU';
    }
    if (s.length > 5){
      return s.slice(0, s.length - 5) + 'TRAM';
    }
    if (s.length > 3){
      return s.slice(0, s.length - 3) + 'NGHIN';
    }
    return s + 'DONG';
  }
  showConfirm(){
    return this.selectedAccount != null && this.amount != 0;
  }
  validateDate(): boolean {
    if (this.bsDate < this.bsConfig.minDate || this.bsDate > this.bsConfig.maxDate) {
      this.messageDate = 'Thời điểm ' + (this.data.type == PaymentEditorType.income ? 'thu' : 'chi') + ' ngoài phạm vi cho phép, vui lòng kiểm tra lại';
      return false;
    }
    else {
      this.messageDate = '';
      return true;
    }
  }

  validateCode(): boolean {
    if (this.confirmation.toLowerCase() != (this.data.shortName + this.selectedAccount + this.getConfirmNumber()).toLowerCase()) {
      this.messageCode = 'Mã xác nhận không đúng, vui lòng kiểm tra lại';
      return false;
    }
    else {
      this.messageCode = '';
      return true;
    }
  }

  emit() {
    if(!this.validateDate() || !this.validateCode()){
      return;
    }
    if (this.selectedAccount == null && this.amount == 0){
      this.messageCode = 'Thông tin không hợp lệ';
      return;
    }
    this.data.date = this.date.transform(this.bsDate, 'dd-MM-yyyy');
    this.data.account = this.selectedAccount;
    this.data.amount = this.amount;
    this.commit.emit(this.data);
    this.modalRef.hide();
  }
}
